<template>
  <Scanner/>
</template>

<script>
import Scanner from './Scanner';

export default {
  name: 'StartPage',
  components: {Scanner},
  data() {
    return {
      showLanding: true
    }
  }
}
</script>
